<template>
  <div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
  data() {
    return {
    }
  },
  watch: {
    '$page.props.flash': {
      handler() {

        if (this.$page.props.flash.success || (this.$page.props.flash.error || Object.keys(this.$page.props.errors).length > 0)) {

          let mTitle = this.$page.props.flash.success
          if (this.$page.props.flash.error || Object.keys(this.$page.props.errors).length > 0) {
            mTitle = 'W formularzu pojawił się błąd.'
            if (Object.keys(this.$page.props.errors).length > 1)
              mTitle = 'W formularzu pojawiły się '+ Object.keys(this.$page.props.errors).length +' błędy.'

            if (Object.keys(this.$page.props.errors).length > 4)
              mTitle = 'W formularzu pojawiło się kilka ('+ Object.keys(this.$page.props.errors).length +') błędów.'
          }
          
          Swal.fire({
            position: 'center',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: this.$page.props.flash.success != null ? 'success' : 'error',
            title: mTitle
          })

        }

      },
      deep: true,
    },
  },

}
</script>
